import { useActivityTracker } from '@/composables/useActivityTracker.ts'
import { ping } from '@/api'

export default {
  install() {
    useActivityTracker({
      onPing: () => ping,
      idleAfterSeconds: 30000,
      pingIntervalMs: 10000
    })
  }
}
